module.exports = __webpack_public_path__ + "static/media/icon.28992553.png";